import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {LoginService} from 'lps-navigation';
import {Subject} from 'rxjs';

import {WidgetInfoModel, WidgetModel} from 'src/app/core/models/widget.model';
import {EnvironmentService} from 'src/app/core/enviroment/environment.service';
import {ManagerFiltersControls} from '../manager-filters/manager-filters.component';
import {getManagerFilterBeginDate, getManagerFilterEndDate} from '../../core/helpers/date.helper';
import {HomeService} from './home.service';

@Injectable({
  providedIn: 'root'
})
export class HomeManagerService {

  private uri = this.environmentService.getEnvVar('api_home');
  public homeData: any;
  public dashData: any;
  public sidebarData: any;
  public sideMenuDraggables: any;
  public profileData: any;

  public getDashDataFinished: boolean;
  public storedDateTime: any;

  public smWidgets: Subject<WidgetModel[]> = new Subject<WidgetModel[]>();
  public smWidgetsSet: WidgetModel[] = [];
  public widgetInfo: Subject<WidgetInfoModel> = new Subject<WidgetInfoModel>();

  constructor(
    public http: HttpClient,
    private loginService: LoginService,
    private homeService: HomeService,
    private environmentService: EnvironmentService
    ) { }

  get jwtToken(): string {
    return this.loginService.getAuthInformation().token;
  }

  public clearHomeCrmToken() {
    this.sidebarData = null;
    this.profileData = null;
    this.getDashDataFinished = false;
  }

  public getCrmHome() {
    return this.http.get<any>(`${this.uri}/crm-home`);
  }

  public getManagerDashWidgets() {
    return this.http.get<any>(`${this.uri}/manager-cards?` + Math.random());
  }

  public getManagerDashWidgetData(id: string, beginDate: string, endDate: string) {
    return this.http.get<any>(
        `${this.uri}/manager-card-info/${id}?begin-date=${beginDate}&end-date=${endDate}&`
        + Math.random());
  }

  public getSmWidgets() {
    return this.smWidgets.asObservable();
  }

  public setSmWidgets(widgets: WidgetModel[]) {
    this.smWidgets.next(widgets);
  }

  public getwidgetInfo() {
    return this.widgetInfo.asObservable();
  }

  public setwidgetInfo(info: WidgetInfoModel) {
    this.widgetInfo.next(info);
  }

  public getManagerDashData() {
    if (!this.jwtToken) { return false; }
    this.dashData = this.getManagerDashWidgets()
        .subscribe(
            (res) => {
              this.setSmWidgets(res.card_items);
              this.smWidgetsSet = res.card_items;
              this.getDashDataFinished = true;
            },
            (err) => console.log(err)
        );
  }

  public fetchManagerWidgetData(widgetId: string, filtersControls: ManagerFiltersControls) {
    if (!this.jwtToken) { return false; }

    const beginDate = getManagerFilterBeginDate(filtersControls);
    const endDate = getManagerFilterEndDate(filtersControls);

    this.getManagerDashWidgetData(widgetId, beginDate, endDate)
        .subscribe(
            (res) => {
              if (res && res.informations) {
                const wInfo: WidgetInfoModel = {
                  id: widgetId,
                  info: res.informations
                };
                this.setwidgetInfo(wInfo);
              }
            },
            (err) => console.log(err)
        );
  }

  public getDraggableSidemenuItems() {
    const sidemenuDraggables = [];
    sidemenuDraggables.push({
      id: '4ae51df7-e019-48cd-9837-99b0a94c83ca',
      action: {
        type: '',
        target: '',
        url: ''
      },
      draggable: true,
      label: 'Visitas realizadas',
      icon: '',
      card_title: 'Visitas realizadas'
    });
    sidemenuDraggables.push({
      id: '1cc360b5-07a7-4529-9c9c-9adf8caf01fc',
      action: {
        type: '',
        target: '',
        url: ''
      },
      draggable: true,
      label: 'Facs recebidas',
      icon: '',
      card_title: 'Facs recebidas'
    });
    sidemenuDraggables.push({
      id: '29204ca6-0d1c-4f4b-bdec-f550c46e234d',
      action: {
        type: '',
        target: '',
        url: ''
      },
      draggable: true,
      label: 'Propostas',
      icon: '',
      card_title: 'Propostas'
    });
    sidemenuDraggables.push({
      id: '0e62279f-29d5-43b8-8976-74ed6642e613',
      action: {
        type: '',
        target: '',
        url: ''
      },
      draggable: true,
      label: 'Facs desatualizadas',
      icon: '',
      card_title: 'Facs desatualizadas'
    });
    this.sideMenuDraggables = sidemenuDraggables;
  }

}
